var MDB = window.MDB || {};;


//Send an ajax request to specified url.
//You will have to make a response class in your controller for your data object if you are using POST.
$.extend(MDB, {
    sendAjaxRequest: function(url, data, method, debug, noErrors) {

        method = method != null ? method.toUpperCase() : null;

        if(debug) {
            console.log(url);
            console.log(data);
            console.log(method);
        }
       
        data !== undefined ? data : {}
        
        if (method == 'POST') {
            data = JSON.stringify(data);
        }

        var def = new $.Deferred();
        $.ajax({
            url: url,
            type: method ? method : 'GET', 
            data: data,
            processData: method != 'POST',
            cache: false,
            contentType: 'application/json;charset=utf8',
            //dataType: 'json',
            success: function (data) { 
                if (!data.errors || data.errors.length === 0) {
                    def.resolve(data);
                } else {
                    MDB.Notify.bootstrapDanger(data.errors);
                    def.reject();
                }
            },
            error: function () {
                if(!noErrors) {
                    MDB.Notify.bootstrapDanger(MDB.loadResourceString('Marketingdb_Ajax_Request_Server_Error_Text'));
                }
                def.reject();
            }
        });
        return def.promise();
    }
});